import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=0d766ba2&scoped=true"
import script from "./smsTemplate.vue?vue&type=script&lang=js"
export * from "./smsTemplate.vue?vue&type=script&lang=js"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=0d766ba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d766ba2",
  null
  
)

export default component.exports